// extracted by mini-css-extract-plugin
module.exports = {"size":"styles_size__3jIrd"};